import type { BossConfig } from '../../entities/BossConfig';
import type { WaveEventConfig } from './WaveEventConfig';
import { BIG_BOAR_CONFIG } from './BigBoar';
import { ELK_CONFIG } from './Elk';
import { BEAR_CONFIG } from './Bear';
import { CAMEL_CONFIG } from './Camel';
import { HONEY_BADGER_CONFIG } from './HoneyBadger';
import { FOX_WAVE_CONFIG } from './FoxWave';
import { WOLF_WAVE_CONFIG } from './WolfWave';
import { BOARLING_WAVE_CONFIG } from './BoarlingWave';
import { DEER_WAVE_CONFIG } from './DeerWave';

export const BOSS_CONFIGS: Record<string, BossConfig> = {
  big_boar: BIG_BOAR_CONFIG,
  elk: ELK_CONFIG,
  bear: BEAR_CONFIG,
  camel: CAMEL_CONFIG,
  honey_badger: HONEY_BADGER_CONFIG,
};

export const WAVE_EVENT_CONFIGS: Record<string, WaveEventConfig> = {
  fox_wave: FOX_WAVE_CONFIG,
  wolf_wave: WOLF_WAVE_CONFIG,
  boarling_wave: BOARLING_WAVE_CONFIG,
  deer_wave: DEER_WAVE_CONFIG,
};

export function getBossConfig(id: string): BossConfig {
  const config = BOSS_CONFIGS[id];
  if (!config) throw new Error(`Unknown boss id: ${id}`);
  return config;
}

export function getWaveEventConfig(id: string): WaveEventConfig {
  const config = WAVE_EVENT_CONFIGS[id];
  if (!config) throw new Error(`Unknown wave event id: ${id}`);
  return config;
}
